import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import { usePathname } from 'next/navigation';

interface MobileTableData {
    products: {
        title: string;
        items: {
            names: {
                title: string;
                image: string;
            }[];
            compatible: boolean;
            outlets: string;
            accessories: string[];
        }[];
    }[];
    title: string;
    compatible: boolean[];
    outlets: string[];
    accessories: string[][];
}

const MobileTable: React.FC<{ data: MobileTableData }> = ({ data }: { data: MobileTableData }) => {
    const { locale } = getLocal();
    const { t } = useLang('CompatibilityTable');

    const compatible: boolean[] = [];
    const outlets: string[] = [];
    const accessories: string[][] = [];
    data.products.forEach((product) => {
        product.items.forEach((item) => {
            compatible.push(item.compatible);
            outlets.push(item.outlets);
            accessories.push(item.accessories);
        });
    });
    const width = 92.7 * compatible.length;

    const pathname = usePathname();
    return (
        <div className={styles.MobileTable}>
            <div style={{ width: `${width}px` }}>
                <div className="title-wrapper">
                    <div className="title">Product</div>
                </div>

                <div className="content product-content">
                    {data.products.map((product, index) => (
                        <div key={index} className="product" style={{ width: `${product.items.length * 92.7}px` }}>
                            <div className="product-title">{product.title}</div>
                            <div className="product-items">
                                {product.items.map((item, index) => (
                                    <div key={index} className="product-item">
                                        {item.names.map((item, index) => (
                                            <div key={index} className="product-item-wrapper">
                                                <EcoImg pc={item.image} />
                                                <div className="product-item-title">{item.title}</div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className=" title2-wrapper">
                    <div className="title2">{t('product_title')}</div>
                </div>
                <div className="title-wrapper">
                    <div className="sub-title">{t('compatibility')}</div>
                </div>

                <div className="content">
                    {compatible.map((item, index) => (
                        <div key={index} className="cell-item">
                            {typeof item === 'boolean' ? (item ? '✅' : '❌') : item}
                        </div>
                    ))}
                </div>

                <div className="title-wrapper ">
                    <div className="sub-title">{t('delta_3_max_plus_outlets')}</div>
                </div>
                <div className="content">
                    {outlets.map((item, index) => (
                        <div key={index} className="cell-item">
                            {item}
                        </div>
                    ))}
                </div>
                <div className="title-wrapper">
                    <div className="sub-title">{t('ecoflow_connection_accessories')}</div>
                </div>
                <div className="content">
                    {' '}
                    {accessories.map((item, index) => (
                        <div key={index} className="cell-item">
                            {item.map((item, index) => (
                                <div key={index} className="cell-item-wrapper">
                                    {item}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            {!pathname?.includes('delta-3-classic-portable-power-station') && <div className="note">{t('note')}</div>}
        </div>
    );
};

export default MobileTable;
